import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type FindTutorInactiveIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function FindTutorInactiveIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: FindTutorInactiveIconProps) {
  return (
    <Svg
      width={29}
      height={29}
      viewBox="0 0 29 29"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M19.139 2.833h-7.183a6.866 6.866 0 00-6.857 6.603h-.932a.874.874 0 000 1.75h.92v6.639h-.885a.875.875 0 000 1.75h.932a6.861 6.861 0 006.857 6.591h7.183a6.866 6.866 0 006.868-6.871v-9.59a6.885 6.885 0 00-4.266-6.356 6.877 6.877 0 00-2.637-.516zm-3.125 4.585a3.613 3.613 0 013.544 4.327 3.617 3.617 0 01-4.936 2.628 3.615 3.615 0 01-2.223-3.35 3.617 3.617 0 013.615-3.605zm4.081 13.498a.874.874 0 01-.874-.875c0-1.411-1.761-2.625-3.207-2.625s-3.195 1.167-3.195 2.625a.876.876 0 01-1.75 0c0-2.508 2.613-4.375 4.945-4.375 2.332 0 4.956 1.867 4.956 4.375a.887.887 0 01-.875.875z"
        className={pathClassName}
      />
      <Path
        d="M17.88 11.023a1.866 1.866 0 11-3.732.024 1.866 1.866 0 013.732-.024z"
        className={pathClassName}
      />
    </Svg>
  );
}

export default FindTutorInactiveIcon;
